@if (src()) {
  <img class="h-full w-full rounded-full object-cover" [src]="src()" [alt]="alt()" />
} @else {
  <span class="bg-primary-600 inline-flex h-full w-full items-center justify-center rounded-full">
    <span class="leading-none font-medium text-white uppercase" [class]="initialsClasses()">
      {{ initials() }}
    </span>
  </span>
}
